import React from 'react';

import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import "./style.css"
import { __FormulaId, __KPIAgregations, __KPIPeriods, __enum_ChartDataserieInputType } from '../../../../../../common/Dictionaries';
import CLabel from '../../../../../../components/Common/CLabel';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';

function AditionalInfoCard(props) {
    const { t } = useTranslation();

    const { 
        inputParam_DataSerie = null,
        inputParam_ListObjetives = null,
        inputParam_ShowDescription = false,
    } = props;

    return (
        <>
        
            <Row className="pt-3">
                <Col>
                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-variablename') } labelValue={ `${inputParam_DataSerie.variableName} (${inputParam_DataSerie.um})` }  />
                </Col>
            </Row>
            {
                inputParam_ShowDescription === true &&
                <Row className="pt-3">
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-description') } labelValue={ !isNullUndefinedOrEmpty(inputParam_DataSerie.description) ? inputParam_DataSerie.description : t('data-lang-lbl-nodata') }  />
                    </Col>
                </Row> 
            }
            <Row className="pt-3">
                <Col>
                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-timeaggregation') } labelValue={ t(__KPIAgregations.find(x => x.key === inputParam_DataSerie.timeAggregationId).title) }  />
                </Col>
                <Col>
                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-measurementperiod') } labelValue={ t(__KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId).title) }  />
                </Col>
            </Row>
            <Row className="pt-3">
                <Col>
                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-field-formulaid') } labelValue={  t(__FormulaId.find(x => x.key === inputParam_DataSerie.formulaId).text) }  />
                </Col>
                <Col>
                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-objetive') } labelValue={ inputParam_ListObjetives !== null ? inputParam_ListObjetives.find(x => x.key === inputParam_DataSerie.objetiveId).text : "" }  />
                </Col>
                <Col xl={12}>
                    <Row className="pt-3">
                        <Col xl={6}>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-useOfVariables') } labelValue={ inputParam_DataSerie.useOfVariables ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') }  />
                        </Col>
                        {
                            inputParam_DataSerie.useOfVariables &&
                            <Col>
                                <Col>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-field-k1') } labelValue={ inputParam_DataSerie.k1 }  />
                                </Col>
                                <Col>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-field-k2') } labelValue={ inputParam_DataSerie.k2 }  />
                                </Col>
                            </Col>
                        }
                    </Row>
                </Col>
            </Row>
        </>
    );
}

AditionalInfoCard.propTypes = {
    inputParam_DataSerie: PropTypes.object.isRequired,
    inputParam_ListObjetives: PropTypes.array,
};

export default AditionalInfoCard;


